/**
 * 내 팀 일정 쿼리 키 — 출퇴근 달력이 팀 마감·휴가·캠페인 일정을 칸에 얹는 데 쓴다.
 *
 * 일정(`attendance-day-schedules`)과 루트를 가른다. 팀 일정은 퀘스트·휴가·캠페인 타임라인에서
 * 파생되는 읽기 전용이라 출퇴근 일정 뮤테이션이 이것을 지울 이유가 없다.
 */
import { defineInvalidation, defineQueryKeys } from '@/shared/lib/queryKeys';

const keys = defineQueryKeys('attendance-team-schedule', (all) => ({
  allPrefix: [...all] as const,
  /** 조회 기간(달력에 보이는 달) */
  range: (from: string, to: string) => [...all, 'range', from, to] as const,
}));

export const {
  keys: teamScheduleKeys,
  root: teamScheduleRoot,
  invalidate: invalidateTeamScheduleScopes,
} = defineInvalidation(keys, {
  all: keys.allPrefix,
});
